export default __webpack_public_path__ + "static/media/exit_arrow.f35c9a55.svg";